import React, { useState,useEffect } from "react";
import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../components/Theme";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import ShowerIcon from "@mui/icons-material/Shower";
import FireExtinguisherIcon from "@mui/icons-material/FireExtinguisher";
import AttractionsIcon from "@mui/icons-material/Attractions";
import WateringTable from "./operation_component/Water";
import FertilizingTable from "./operation_component/Fertilizing";
import Chemical from "./operation_component/Chemical";
import Harvest from "./operation_component/Harvest";

const eventItems = [
  { label: "การให้น้ำ", icon: WaterDropIcon, key: "water" },
  { label: "การให้ปุ๋ย", icon: ShowerIcon, key: "fertilizer" },
  { label: "การให้สารเคมี", icon: FireExtinguisherIcon, key: "chemical" },
  { label: "การเก็บเกี่ยว", icon: AttractionsIcon, key: "harvest" },
];

const Event = ({ appCropId }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedMenu, setSelectedMenu] = useState("water");
  const [selected, setSelected] = useState(null);
  useEffect(() => {
    if (appCropId) {
    }
  }, [appCropId]);
  const renderContent = () => {
    switch (selectedMenu) {
      case "water":
        return <WateringTable appCropId={appCropId}/>;
      case "fertilizer":
        return <FertilizingTable appCropId={appCropId}/>;
      case "chemical":
        return <Chemical appCropId={appCropId}/>;
      case "harvest":
        return <Harvest appCropId={appCropId}/>;
      default:
        return <Typography>กรุณาเลือกเมนู</Typography>;
    }
  };

  return (
    <Box>
      <Grid container spacing={2} p={isMobile ? 2 : 6}>
        {eventItems.map((item) => {
          const isActive = selected === item.key;

          return (
            <Grid item size={{ xs: 6, md: 6, lg: 3, xl: 3 }} key={item.key}>
              <Box
                onClick={() => {
                  setSelected(item.key);
                  setSelectedMenu(item.key);
                }}
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                gap={isMobile ? 0.5 : 1}
                p={isMobile ? 1 : 2}
                border="2px solid"
                borderColor={isActive ? colors.greenAccent[400] : "transparent"}
                borderRadius="12px"
                sx={{
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  backgroundColor: isActive
                    ? colors.greenAccent[400]
                    : theme.palette.background.paper,
                  "&:hover": {
                    backgroundColor: colors.greenAccent[400],
                    "& .text, & .icon": {
                      color: "#fff",
                    },
                  },
                }}
              >
                <Box display="flex" alignItems="center" gap={2}>
                  <item.icon
                    className="icon"
                    sx={{
                      ml: "10px",
                      color: isActive ? "#fff" : colors.greenAccent[400],
                      transition: "color 0.3s ease",
                      fontSize: isMobile ? "15px" : "none",
                    }}
                  />
                  <Typography
                    className="text"
                    fontWeight="bold"
                    sx={{
                      fontSize: isMobile ? "14px" : "none",
                      color: isActive ? "#fff" : "#000",
                      transition: "color 0.3s ease",
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
      {renderContent()}
    </Box>
  );
};

export default Event;
